// .executor.js files must be excused from babel-loader since
// threads-plugin want to replace whatever is inside new Worker(...)
import { spawn, Worker, Thread } from 'threads/dist';

export async function hashFilesWithWorker(files, progressListener) {
  let lgtFileHasher;
  let progressSubscription;
  try {
    lgtFileHasher = await spawn(new Worker('./LGTFileHasher.threadWorker.js'));
    // const lgtFileHasher = await LGTFileHasherThread();
    progressSubscription = lgtFileHasher.progressObservable()
      .subscribe(progressListener, err => {
        console.log('Some error occured in LgtFileHasher', err);
      });
    return await lgtFileHasher.hashFiles(files);
  } catch (error) {
    console.error('LGTFileHasher thread errored:', error);
  } finally {
    if (lgtFileHasher) {
      await Thread.terminate(lgtFileHasher);
    }
    if (progressSubscription && !progressSubscription.closed) {
      progressSubscription.unsubscribe();
    }
  }
  return false;
}
